import { render, staticRenderFns } from "./CardKultour.vue?vue&type=template&id=75ca8146&scoped=true"
import script from "./CardKultour.vue?vue&type=script&lang=js"
export * from "./CardKultour.vue?vue&type=script&lang=js"
import style0 from "./CardKultour.vue?vue&type=style&index=0&id=75ca8146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca8146",
  null
  
)

export default component.exports